import type { Product, Variant } from '~/stores/product/types';
import type { Currency } from '~/utils/common';

export const formatPrice = (locale: Locale, price: number | null, currency: Currency | null): string => {
  if (price && currency) {
    return (
      calculatePrice(price)?.toLocaleString(locale, {
        currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
        style: 'currency',
      }) ?? ''
    );
  }

  return price?.toString() ?? '';
};

export const calculatePrice = (price: number | null): number | null => (price ? price / 100 : null);

export const getPrice = (
  product: Product,
  currencyCode: string,
  variantSku?: string | null,
  discount = false,
): Price | null => {
  let price: Price | undefined;
  let finalProduct: Product | Variant = product;

  if (variantSku) {
    finalProduct = product.variants?.find((v) => v.sku === variantSku) ?? product;
  }

  if (discount) {
    if (finalProduct.discounted_prices?.length) {
      price = finalProduct.discounted_prices.find((p) => p.currency_code === currencyCode);
    }
  } else if (finalProduct.prices?.length) {
    price = finalProduct.prices.find((p) => p.currency_code === currencyCode);
  }

  return price ?? null;
};

export const getCurrencySymbol = (locale: Locale, currency: Currency): string =>
  (0)
    .toLocaleString(locale, { currency, maximumFractionDigits: 0, minimumFractionDigits: 0, style: 'currency' })
    .replace(/\d/g, '')
    .trim();
